import React, {useEffect, useRef, useState} from 'react';
import '../css/components/Footer.css';
import Acordeon from '../components/Acordeon.js';

function Footer(props) {
  const { cmbFooter } = props;
  const elementRef = useRef();
  const [availableAcordeonTypes, setAvailableAcordeonTypes] = useState([]);
  const [acordeonesData, setAcordeonesData] = useState([]);

  useEffect(() => {
    let Acordeones = [];

    try {
      // Verificar si existen elementos con el nombre "terminos"
      const elementosTerminos = obtenerAcordeonPorNombre(cmbFooter, 'terminos');
      if (elementosTerminos && elementosTerminos.length > 0) {
        Acordeones.push({nombre: 'Terminos', valor: elementosTerminos});
      }

      // Verificar si existen elementos con el nombre "abrir" antes de añadirlos
      const elementosAbrir = obtenerAcordeonPorNombre(cmbFooter, 'abrir');
      if (elementosAbrir && elementosAbrir.length > 0) {
        Acordeones.push({nombre: 'Abrir', valor: elementosAbrir});
      }
      
      // Establecer los tipos de acordeones disponibles
      setAvailableAcordeonTypes(Acordeones.map(acordeon => acordeon.nombre));
      setAcordeonesData(Acordeones);
    } catch (error) {
      console.error('Error en el procesamiento de los acordeones:', error);
    }

    if (elementRef.current && elementRef.current.id === 'split-bot-cuerpo') {
      elementRef.current.style.minHeight = 0 + 'px';
    }
  }, [cmbFooter]);

   // Nuevo useEffect para construir HTML después de que Acordeon se haya actualizado
  useEffect(() => {
    // Pequeño retraso para asegurar que el DOM se ha actualizado
    const timer = setTimeout(() => {
      acordeonesData.forEach((acordeon) => construirHTML(acordeon));
    }, 100);
    
    return () => clearTimeout(timer);
  }, [acordeonesData]);
  
  function obtenerAcordeonPorNombre(lista, nombre) {
    if (!lista || !Array.isArray(lista) || lista.length === 0) {
      return [];
    }
    return lista
      .filter((elemento) => elemento && elemento.nombre === nombre)
      .sort((a, b) => {
        // Manejo robusto para códigos no numéricos
        try {
          return parseInt(a.codigo) - parseInt(b.codigo);
        } catch (e) {
          // Si hay un error en la conversión, mantener el orden original
          return 0;
        }
      });
  }
  function construirHTML(acordeon) {
    let footerElement = document.getElementById(`footer${acordeon.nombre}`);

    if (footerElement !== null) {
      let resfooterSolicitarElement = [];

      acordeon.valor.forEach((footer) => {
        if (footer && footer.valor) {
          resfooterSolicitarElement.push(footer.valor);
        }
      });

      footerElement.innerHTML = resfooterSolicitarElement.join('');
    }
  }

  return (
    <div className='footer-content'>
      <div className='footerComp bg-sphericaSecondary text-sphericaPrimary rounded-16'>
        <div className='footerComp__contenedor'>
          <Acordeon 
            ref={elementRef} 
            availableTypes={availableAcordeonTypes} 
          />
        </div>
      </div>
    </div>
  );
}

export default Footer;